module.exports = __webpack_public_path__ + "img/oval.96d90605.png";